<script lang="ts">
import { defineComponent } from "vue";
import { VIEW_COMPONENTS } from "./view-components";

export default defineComponent({
  components: { ...VIEW_COMPONENTS },
});
</script>
